// extracted by mini-css-extract-plugin
export default {"title":"HeaderShort_title__08SIw","menu-button":"HeaderShort_menu-button__csSQg","menu":"HeaderShort_menu__ht9xG","menu-link":"HeaderShort_menu-link__xTLgf"};